import React from "react";
import { Link } from "react-router-dom";
import { FaDownload, FaGamepad, FaShoppingBag, FaTrophy } from "react-icons/fa";
import { DOWNLOAD_URL, games } from "../data/siteCatalog";
import "../style/HomeSections.css";

const stats = [
  { value: "Gratis", label: "Zombie Crushers" },
  { value: "Scheda", label: "WarFront" },
  { value: "Playtest", label: "Ghost Hunter" }
];

const proofPoints = [
  {
    icon: FaTrophy,
    title: "Zombie Crushers si pu\u00f2 giocare subito",
    description: "Lo aggiungi dal launcher Kyros, fai una run e confronti il punteggio in classifica."
  },
  {
    icon: FaShoppingBag,
    title: "WarFront passa prima dalla scheda",
    description: "Prima del checkout trovi prezzo, requisiti, licenza e modo di installazione."
  },
  {
    icon: FaGamepad,
    title: "Ghost Hunter resta in lavorazione",
    description: "Non lo vendiamo ancora: mostriamo il tono del gioco e apriamo i test quando ha senso."
  }
];

export default function HomeIntro() {
  return (
    <section className="home-intro">
      <div className="home-intro__inner">
        <div className="home-intro__lead">
          <span className="home-eyebrow">Kyros Games</span>
          <h1>Giochi Kyros per Windows, scaricati dal nostro launcher</h1>
          <p>
            Qui trovi solo i videogame che stiamo producendo noi: Zombie Crushers si gioca gratis,
            WarFront passa dallo Store e Ghost Hunter resta visibile mentre lo sviluppiamo.
          </p>
          <div className="home-intro__cta">
            <Link className="home-button home-button--primary" to="/store">
              Apri lo Store
            </Link>
            <Link className="home-button home-button--outline" to="/games/zombie-crushers">
              Gioca Zombie Crushers
            </Link>
            <a className="home-button home-button--outline" href={DOWNLOAD_URL} download>
              <FaDownload aria-hidden="true" />
              Scarica il launcher
            </a>
          </div>
          <ul className="home-intro__stats">
            {stats.map(item => (
              <li key={item.label}>
                <span>{item.value}</span>
                <small>{item.label}</small>
              </li>
            ))}
          </ul>
        </div>

        <div className="home-intro__game-stack" aria-label="Giochi Kyros in evidenza">
          {games.map(game => (
            <Link key={game.id} to={game.route} className="home-game-card">
              <img src={game.image} alt="" />
              <div>
                <span>{game.status}</span>
                <h2>{game.name}</h2>
                <p>{game.storeStatus}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>

      <div className="home-intro__proof-strip" aria-label="Stato dei giochi Kyros">
        {proofPoints.map(point => {
          const Icon = point.icon;
          return (
            <article key={point.title}>
              <Icon aria-hidden="true" />
              <div>
                <h3>{point.title}</h3>
                <p>{point.description}</p>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}
